// Back arrow for the mobile shells' header — shown on every page except the home screen, so
// a page reached straight from the bottom bar always has a way back.
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function ShellBackButton({ homePath = "/" }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  if (pathname === homePath || pathname === `${homePath}/`) return null;
  const goBack = () => {
    // react-router keeps the position of the entry in history.state.idx: 0 = nothing to go back to
    // (page opened directly / refreshed), so fall back to Home instead of leaving the app.
    const idx = window.history.state?.idx;
    if (typeof idx === "number" && idx > 0) navigate(-1);
    else navigate(homePath, { replace: true });
  };
  return (
    <button
      type="button" onClick={goBack} aria-label="Back" data-testid="shell-back-btn"
      className="h-9 w-9 -ml-1 mr-1 shrink-0 rounded-full flex items-center justify-center text-neutral-700 hover:bg-neutral-100 active:bg-neutral-200"
    >
      <ArrowLeft className="h-5 w-5" />
    </button>
  );
}
